import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import CategoriaDocumentoService from "service/documentos/CategoriaDocumentoService";
import { TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const categoriaDocumentoService = new CategoriaDocumentoService();

export default function CategoriaDocumentoListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Categorias');

    const defaultFilters: DataTableFilterMeta = {
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        prefixo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={categoriaDocumentoService} urlService="/categoriaDocumento" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="categoriaDocumento" >
            <Column field="prefixo" header="Prefixo" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
        </BaseListagem>
    )
}